import { Building, Car, Home, Laptop, PiggyBank, Refrigerator, Search, ShoppingBag, Sofa, Tv, Users, Wallet, WashingMachine, Wrench, FileText, Flame, Target } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

export const Chip = ({ active, onClick, icon: Icon, label, tone = "mint", testid }) => (
  <button type="button" onClick={onClick} data-testid={testid} aria-pressed={active}
    className={cn("flex items-center gap-2.5 rounded-2xl border px-4 py-3 text-left text-sm font-medium transition-all duration-200", `tone-${tone}`,
      active ? "tone-tile border-transparent shadow-sm" : "border-border bg-card hover:-translate-y-0.5")}>
    <span className="tone-chip flex h-8 w-8 shrink-0 items-center justify-center rounded-xl"><Icon className="h-4 w-4" /></span>
    {label}
  </button>
);

export const Field = ({ id, label, ...props }) => (
  <div><Label htmlFor={id}>{label}</Label><Input id={id} className="mt-1.5 h-11 rounded-xl" {...props} /></div>
);

export const HOUSING = [
  { key: "apartment", label: "Appartement", icon: Building, tone: "sky" },
  { key: "house", label: "Maison", icon: Home, tone: "peach" },
  { key: "shared", label: "Colocation", icon: Users, tone: "lilac" },
  { key: "other", label: "Autre", icon: Sofa, tone: "butter" },
];

export const PRIORITIES = [
  { key: "budget", label: "Maîtriser mon budget", icon: Wallet, tone: "butter", widgets: ["budget", "spending"] },
  { key: "savings", label: "Épargner pour mes projets", icon: PiggyBank, tone: "peach", widgets: ["goals"] },
  { key: "warranties", label: "Suivre mes garanties", icon: Target, tone: "sky", widgets: ["equipments", "patrimoine"] },
  { key: "docs", label: "Retrouver mes documents", icon: FileText, tone: "lilac", widgets: ["documents"] },
  { key: "care", label: "Anticiper l'entretien", icon: Wrench, tone: "mint", widgets: ["maintenance", "tickets"] },
  { key: "sell", label: "Revendre ce qui ne sert plus", icon: ShoppingBag, tone: "rose", widgets: ["market"] },
];

export const QUICK_ASSETS = [
  { name: "Réfrigérateur", category: "appliance", room: "Cuisine", icon: Refrigerator, tone: "sky" },
  { name: "Lave-linge", category: "appliance", room: "Salle de bain", icon: WashingMachine, tone: "mint" },
  { name: "Télévision", category: "multimedia", room: "Salon", icon: Tv, tone: "lilac" },
  { name: "Ordinateur portable", category: "computer", room: "Bureau", icon: Laptop, tone: "butter" },
  { name: "Voiture", category: "vehicle", room: "Garage", icon: Car, tone: "peach" },
  { name: "Chaudière", category: "installation", room: "Cellier", icon: Flame, tone: "rose" },
];

export const ROOMS = ["Cuisine", "Salon", "Chambre", "Salle de bain", "Bureau", "Garage", "Cellier", "Extérieur", "Autre"];
export const SearchIcon = Search;
